import { MessageOption, MessageOptionType } from "@/types/conversationTypes";
import FlightOption from "./flight-option/FlightOption";
import RegularOption from "./RegularOption";
import EventOption from "./EventOption";
import TourOption from "./TourOption";
import AccommodationOption from "./AccommodationOption";
import ArticleOption from "./ArticleOption";

interface Props {
  options: MessageOption[];
  isConversationClosed?: boolean;
  onOptionSelect?: (id: string, title: string) => void;
}

const MessageOptions = ({ options, onOptionSelect, isConversationClosed }: Props) => {
  const flightOptions = options.filter(o => o.type === MessageOptionType.FLIGHT && o.flightDetails);
  const accommodationOptions = options.filter(o => o.type === MessageOptionType.ACCOMMODATION && o.accommodationDetails);
  const eventOptions = options.filter(o => o.type === MessageOptionType.EVENT && o.eventDetails);
  const tourOptions = options.filter(o => o.type === MessageOptionType.TOUR && o.tourDetails);
  const articleOptions = options.filter(o => o.type === MessageOptionType.ARTICLE && o.articleDetails);
  
  // Regular = absence of type (null/undefined) 
  const regularOptions = options.filter(o => (o.type == null));

  return (
    <div className="mt-3 space-y-3">
      {flightOptions.map(option => (
        <FlightOption key={option.id} option={option} />
      ))}
      {accommodationOptions.map(option => (
        <AccommodationOption key={option.id} option={option} />
      ))}
      {eventOptions.map(option => (
        <EventOption key={option.id} option={option} />
      ))}
      {tourOptions.map(option => (
        <TourOption key={option.id} option={option} />
      ))}
      {articleOptions.map(option => (
        <ArticleOption key={option.id} option={option} />
      ))}
      {regularOptions.map(option => (
        <RegularOption
          key={option.id}
          option={option}
          onOptionSelect={onOptionSelect}
          isDisabled={isConversationClosed}
        />
      ))}
    </div>
  );
};

export default MessageOptions;
